import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { IhmConfiguration, IHM_CONFIG, IHM_CONFIG_NAME } from './ihm-configuration.model';

// @dynamic
@Injectable()
export class IhmConfigurationService<T extends IhmConfiguration> {
  private configuration: any;

  constructor (private http: HttpClient, @Inject(IHM_CONFIG_NAME) private appName: string, @Inject(IHM_CONFIG) private config: T) {
    this.configuration = this.config;
  }

  public get(): T {
    return this.configuration;
  }

  public initialize(): Promise<void> {
    const randomValue = new Date().getTime();

    if (this.appName) {
      return this.http
        .get(`./${this.appName}.json?${randomValue}`)
        .pipe(
          tap((value: any) => (this.configuration = { ...this.configuration, ...value })),
          catchError((error: any) => {
            console.error('Hey! Something went wrong here.', error);
            return of();
          })
        )
        .toPromise();
    }

    return Promise.resolve(null);
  }
}
